// extracted by mini-css-extract-plugin
module.exports = {"container":"ModalAuth_container__UpQVk"};